import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { PACKAGES_BASE_QUERY_KEY } from '@/api/packages/get-packages-dashboard'
import { PackageModel } from '@/models'
import { composeFormData } from '@/utils'
import { resetQueries } from '@/utils/api'

type AddPackageRequest = Partial<PackageModel>

export const addPackage = async (data: AddPackageRequest): Promise<PackageModel> => {
  const response = await authAPI.post<PackageModel>('/packages', composeFormData(data), {
    headers: {
      'content-type': 'multipart/form-data',
    },
  })
  return response.data
}

export const useAddPackage = () => {
  return useMutation({
    mutationFn: addPackage,
    onSuccess: () => {
      resetQueries([PACKAGES_BASE_QUERY_KEY])
    },
  })
}
